<template>
  <div class="ml-1 mr-1" :class="{ hidden: !visible }" ref="root">
    <v-sheet
      v-if="visible"
      elevation="3"
      class="py-1 px-1 pr-2 project-tile"
      :class="{ toDelete: project.toDelete }"
      @click.native="redirectToNew"
    >
      <v-layout row class="mb-1">
        <v-flex
          xs12
          class="d-flex align-start justify-space-between d-flex-initial"
        >
          <div class="d-flex">
            {{ head }}
            <div class="projectState">{{ state }}</div>
          </div>

          <v-layout column align-end>
            <v-chip
              v-for="tag in project.tags"
              :key="tag"
              small
              class="tag-chip"
            >
              {{ tag }}
            </v-chip>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout
        v-if="serviceWish"
        row
        justify-space-between
        style="font-size: 12px; flex-wrap: wrap"
      >
        <v-flex class="d-flex align-center d-flex-initial">
          <v-icon class="mr-1" size="13px" :title="serviceWish.text">
            {{ serviceWish.icon }}
          </v-icon>
        </v-flex>
      </v-layout>

      <v-layout row v-for="alert in project.activeAlerts" :key="alert">
        <v-flex xs12 class="alert">{{ alert }}</v-flex>
      </v-layout>

      <v-layout
        row
        justify-space-between
        style="font-size: 12px; flex-wrap: wrap"
      >
        <v-flex class="d-flex align-center d-flex-initial">
          <v-icon class="mr-1" size="13px" title="Lead">face</v-icon>
          <div class="mr-1">{{ project.assignees.lead || "???" }}</div>
          <v-icon class="mr-1" size="13px" title="Commercial">work</v-icon>
          <div class="mr-1">{{ project.assignees.sale || "???" }}</div>
          <v-icon class="mr-1" size="13px" title="Reloc">home</v-icon>
          <div class="mr-1">{{ project.assignees.reloc || "???" }}</div>
          <v-icon
            class="mr-1"
            size="13px"
            v-if="project.dateMove != null"
            title="Date de déménagement"
            >date_range</v-icon
          >
          <span v-if="project.dateMove != null">{{
            project.dateMove | shortDate
          }}</span>
        </v-flex>
        <v-flex class="d-flex align-center justify-end d-flex-initial">
          <v-icon
            class="mr-1"
            size="13px"
            color="orange"
            v-if="showSignatureWarning"
            >draw</v-icon
          >
          <v-icon class="mr-1" size="13px" v-if="project.companyId"
            >domain</v-icon
          >
          <v-icon
            color="brown"
            size="13px"
            class="mr-1"
            v-if="project.progress && project.progress.stopped != null"
            >clear</v-icon
          >
          <v-icon class="mr-1" v-else size="13px" title="Dernier mouvement"
            >history</v-icon
          >
          {{ lastDate | shortDate }}
        </v-flex>
      </v-layout>
    </v-sheet>
  </div>
</template>

<script>
import { PROJECTS_COLUMNS_NAMES } from "@/data/DefaultSettings";
import * as _ from "lodash";
import { SERVICE_WISH } from "../../../webapp-commons/data";
import { fetchHil } from "../utils";
import { mapState } from "vuex";

export default {
  name: "ProjectTile",
  data: function() {
    return {
      visible: false
    };
  },
  props: ["project"],
  timers: {
    refreshVisibility: { time: 500, autostart: true, repeat: true }
  },
  computed: {
    ...mapState("notifications", {
      allNotifications: state => state.all
    }),

    state() {
      return PROJECTS_COLUMNS_NAMES[this.project.currentProgress] || "Inconnu";
    },
    lastStepChange() {
      return Math.max.apply(
        Math,
        Object.values(this.project.progress).map(v => new Date(v))
      );
    },
    lastDate() {
      if (
        this.project.progress &&
        Object.keys(this.project.progress).length > 0
      ) {
        if (this.project.lastName === "babibur") {
          console.log(this.project.progress);
        }
        return this.lastStepChange;
      } else {
        return this.progress.projectCreated;
      }
    },
    head() {
      return this.project.lastName != null
        ? this.project.firstName + " " + this.project.lastName
        : this.project.userId;
    },
    notifications() {
      return this.allNotifications.filter(
        ({ idProject, seen }) => !seen && idProject === this.project._id
      );
    },
    showSignatureWarning() {
      return (
        this.project.currentProgress === "awaitingSignature" &&
        !_.some(this.project.signatures, { step: "mission_done" })
      );
    },
    serviceWish() {
      if (!this.project.serviceWish) {
        return null;
      }

      return SERVICE_WISH.find(
        ({ value }) => value === this.project.serviceWish
      );
    }
  },
  methods: {
    refreshVisibility() {
      const rect = this.$refs.root.getBoundingClientRect();
      const ww = document.documentElement.clientWidth;
      const wh = document.documentElement.clientHeight;

      if (
        rect.right < 0 ||
        rect.bottom < 0 ||
        rect.left > ww ||
        rect.top > wh
      ) {
        return;
      }

      this.visible = true;
      this.$timer.stop("refreshVisibility");
    },
    redirectToNew() {
      this.$router.push(`/project/${this.project._id}`);
    },
    async updateAssignee({ role, trigram }) {
      await fetchHil(`/lease/${this.project._id}`, {
        method: "POST",
        body: { [role]: trigram }
      });
      this.$emit("update");
    }
  }
};
</script>

<style scoped>
.project-tile {
  cursor: pointer;
  margin: 0 0 0 5px;
  min-width: 240px;
  opacity: 1;
  transition: opacity ease-in 300ms, height ease-in 300ms;
}

.project-tile.toDelete {
  background: red;
}

.alert {
  font-size: 9px;
  background: #ff7c5d;
  border-radius: 3px;
  padding: 2px 5px;
  margin-right: 8px;
  margin-bottom: 8px;
  color: white;
}

.hidden {
  background: white;
  height: 50px;
  opacity: 0.3;
  min-width: 240px;
}

.projectState {
  display: none;
}

.tag-chip {
  max-width: 100%;
}

.tag-chip >>> .v-chip__content {
  max-width: 100%;
  display: inline-block;
  height: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media screen and (max-width: 450px) {
  .projectState {
    display: block;
    background-color: lightblue;
    border-radius: 9px;
    font-size: 11px;
    padding: 3px 5px 3px 5px;
    margin-left: 20px;
  }
}
</style>
